import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";

export default function PaymentCancelled() {
    return (
        <div className="section" data-testid="payment-cancelled-page">
            <div className="container-atm">
                <div className="card-soft mx-auto max-w-2xl p-10 text-center">
                    <span className="mx-auto inline-flex rounded-full bg-amber-50 p-3 text-amber-600">
                        <AlertTriangle size={32} />
                    </span>
                    <h1 className="mt-6 text-3xl font-semibold">Payment cancelled</h1>
                    <p className="mt-3 text-[15px] text-[#475569]">
                        Your booking request is saved as unpaid. You can try the payment again
                        whenever you&apos;re ready — no card was charged.
                    </p>
                    <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                        <Link to="/book" className="btn-primary inline-flex" data-testid="cancelled-try-again">
                            Try payment again <ArrowRight size={16} />
                        </Link>
                        <Link to="/about" className="btn-secondary inline-flex">
                            Contact us
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
